import { useEffect, useState } from "react";
import { requestGetHTMLDataFromUrl } from "../api";

export const useGetProductLinksFromMshake = (
  url: string,
  isInvalidURL: boolean
) => {
  const [links, setLinks] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  useEffect(() => {
    const fetchData = async (url: string) => {
      let response = null;
      try {
        response = await requestGetHTMLDataFromUrl(url);
      } catch (error) {
        console.error("Error fetching HTML:", error);
        setIsLoading(false);
        setIsError(true);
      }
      if (response?.data) {
        const htmlValue = response.data;
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlValue, "text/html");
        const regex = /look\d+-links__link-container/;
        const classValue = response?.data?.match(regex)[0];
        const items = doc.querySelectorAll(`.${classValue}`);
        const links = [];
        for (let i = 0; i < items?.length; i++) {
          const href = items[i]
            ?.getElementsByTagName("a")[0]
            ?.getAttribute("href");
          if (href) {
            links.push(href);
          }
        }
        setLinks(links);
        setIsLoading(false);
        setIsError(false);
      }
    };
    if (url && !isInvalidURL) {
      setIsLoading(true);
      fetchData(url);
    }
  }, [url, isInvalidURL]);

  return { isLoading, links, isError };
};
